module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Hello world.\n","frontmatter":{"title":"Hello World","path":"some-path","tags":["tag-1","tag-2","sample"]},"fields":{"slug":"/hello-world/"}}}]},"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}}},"pathContext":{"tag":"tag-2"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-tag-2.json
// module id = 419
// module chunks = 125591511704180